/**
 * HR Overtime Service - API client for staff overtime claims: record,
 * approve/reject, and push approved hours into payroll as a
 * PayrollAdjustment.
 */
import api from '../utils/api';

const hrOvertimeService = {
  list: async (filters = {}) => {
    try {
      return await api.get('/api/hr/overtime', { params: filters });
    } catch (error) {
      console.error('Error fetching overtime records:', error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      return await api.post('/api/hr/overtime', data);
    } catch (error) {
      console.error('Error creating overtime claim:', error);
      throw error;
    }
  },

  approve: async (id) => {
    try {
      return await api.post(`/api/hr/overtime/${id}/approve`, {});
    } catch (error) {
      console.error('Error approving overtime record:', error);
      throw error;
    }
  },

  reject: async (id, reason = '') => {
    try {
      return await api.post(`/api/hr/overtime/${id}/reject`, { rejection_reason: reason });
    } catch (error) {
      console.error('Error rejecting overtime record:', error);
      throw error;
    }
  },

  pushToPayroll: async (id, payrollRunId) => {
    try {
      return await api.post(`/api/hr/overtime/${id}/push-to-payroll`, null, { params: { payroll_run_id: payrollRunId } });
    } catch (error) {
      console.error('Error pushing overtime record to payroll:', error);
      throw error;
    }
  },
};

export default hrOvertimeService;
